export enum SmartFilterDataType {
  Unknown = 'Unknown',
  DateTime = 'DateTime',
  Number = 'Number',
  String = 'String',
  DateTimePeriod = 'DateTimePeriod',
  Reserved = 'Reserved',
  Search = 'Search',
  SearchAll = 'SearchAll',
  Unread = 'Unread',
}
